import { useState } from "react";
import { FormField } from "./FormField.tsx";
import { Textarea } from "../atoms/Textarea.tsx";
import { renderMarkdown } from "../../lib/markdown.tsx";

interface Props {
  label: string;
  value: string;
  onChange: (v: string) => void;
  rows?: number;
  error?: string;
}

/**
 * A markdown textarea with a live "how it looks on the site" preview. Toggle
 * between a split view (editor + preview) and edit-only. The preview reuses the
 * website's `.note-content` styling via the `.md-preview` container.
 */
export function MarkdownField({ label, value, onChange, rows = 10, error }: Props) {
  const [showPreview, setShowPreview] = useState(true);

  return (
    <FormField label={label} error={error}>
      <div className="md-field-bar">
        <button
          type="button"
          className={`md-tab${showPreview ? " active" : ""}`}
          onClick={() => setShowPreview(true)}
        >
          Split
        </button>
        <button
          type="button"
          className={`md-tab${showPreview ? "" : " active"}`}
          onClick={() => setShowPreview(false)}
        >
          Edit only
        </button>
      </div>
      <div className={`md-field${showPreview ? " split" : ""}`}>
        <Textarea mono value={value} rows={rows} onChange={(e) => onChange(e.target.value)} />
        {showPreview && (
          <div className="md-preview" aria-label="Website preview">
            {value.trim() ? (
              <div className="note-content">{renderMarkdown(value)}</div>
            ) : (
              <p className="md-preview-empty">Nothing to preview yet.</p>
            )}
          </div>
        )}
      </div>
    </FormField>
  );
}
